import { useEffect, useState, useRef } from 'react'

import { AnimatePresence, motion } from 'framer-motion';

import IphoneFrame from '../../assets/iphone-frame.png'

import p1 from '../../assets/bg/p1.png';
import p2 from '../../assets/bg/p2.png';
import p3 from '../../assets/bg/p3.png';
import p4 from '../../assets/bg/p4.png';
import p5 from '../../assets/bg/p5.png';
import p6 from '../../assets/bg/p6.png';
import p7 from '../../assets/bg/p7.png';

export function IphoneFrameMask({
  children,
}) {
  const [frameIsLoaded, setFrameIsLoaded] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const frameRef = useRef(null)
  const contentDiv = useRef(null)

  const images = [
    p1,
    p2,
    p3,
    p4,
    p5,
    p6,
    p7,
  ].sort(() => Math.random() - 0.5);

  // Check window size
  useEffect(() => {
    setIsMobile(window.innerWidth <= 474)
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 474)
      if (
        frameRef.current?.clientWidth !== undefined &&
        contentDiv.current !== null
      ) {
        contentDiv.current.style.width = `${
          (frameRef.current.clientWidth * 92) / 100
        }px`

        // Border calculation
        // Max value is 62px - when frame has max height

        const relativeBorderRadius = 62 * (frameRef.current.clientHeight / 970)
        contentDiv.current.style.borderRadius = `${relativeBorderRadius}px`
      }
    }

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [frameIsLoaded])

  useEffect(() => {
    if (frameRef.current?.clientWidth !== undefined) {
      contentDiv.current.style.width = `${
        (frameRef.current.clientWidth * 92) / 100
      }px`
    }
    if (
      frameRef.current?.clientHeight !== undefined &&
      contentDiv.current?.style !== undefined
    ) {
      const relativeBorderRadius = 62 * (frameRef.current.clientHeight / 970)
      contentDiv.current.style.borderRadius = `${relativeBorderRadius}px`
    }
  }, [frameIsLoaded, isMobile])

  const [pIndex, setPIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPIndex(prevCount => (prevCount + 1) % 7);
    }, 1000);

    return () => clearInterval(interval);
  }, []);


  return (
    <>
      {isMobile ? (
        children
      ) : (
        <div className="relative z-10 h-full w-full">
          <AnimatePresence mode="wait">
            <motion.img 
              src={images[pIndex]} 
              key={pIndex}
              alt="Background" 
              className='absolute -z-10 w-screen h-screen object-cover brightness-50 blur-[2px]'
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25, ease: 'easeInOut' }}
              />
          </AnimatePresence>
          <img
            src={IphoneFrame}
            alt="iPhone frame"
            className="fixed left-1/2 top-1/2 z-10 flex aspect-[237/485] h-[98%] max-h-[970px] -translate-x-1/2 -translate-y-1/2 flex-col items-center"
            ref={frameRef}
            onLoad={() => {
              setFrameIsLoaded(true)
            }}
          />
          {/* <div className="spin absolute -left-16 -top-16 h-80 w-80">
            <CircularText CX={50} CY={50} R={20.5} fontSize={7} />
          </div> */}
          <div
            className="fixed left-1/2 top-1/2 z-30 h-[95%] max-h-[936px] -translate-x-1/2 -translate-y-1/2 overflow-hidden rounded-[62px] "
            ref={contentDiv}
          >
            <div className="scrollbar-hide relative h-full w-full overflow-scroll bg-transparent">
              {children}
            </div>
          </div>
        </div>
      )}
    </>
  )
}
